module.exports = __webpack_public_path__ + "static/media/banner.988bf778.png";